<template>
  <div class="page">
    <div class="pop-box">
      <div style="min-height: 350px">
        <van-image v-if="imgLink" :src="imgLink | imgUrl('share')" class="share-img">
          <template v-slot:error>
            <van-icon size="20" :name="require('../../assets/imgs/img-fail@3x.png')"></van-icon>
          </template>
        </van-image>
      </div>
      <p class="share-tip">长按图片，把医生分享给朋友</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      doctorId: '',
      imgLink: ''
    };
  },
  created() {
    this.doctorId = this.$route.query.doctorId;
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$fetch.getDoctorDetail(this.doctorId).then((data) => {
        this.imgLink = data.hospitalDoctorWechatShareUrl || '';
      });
    }
  }
};
</script>
<style lang="less" scoped>
.page {
  padding: 15px 8px;
  height: 100%;
  background: #f5f5f5;
  .pop-box {
    width: 100%;
    max-width: 740px;
    margin: 0 auto;
    background: #fff;
    // padding: 20px 12.5px;
    padding-bottom: 35px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    .share-img {
      width: 100%;
      min-height: 250px;
      // box-shadow: #ebedf0 0 4px 12px;
      flex: 1;
    }
    .share-tip {
      width: 250px;
      margin: 0 auto;
      // margin-top: 35px;
      background: #e4ecf5;
      border-radius: 18px;
      text-align: center;
      padding: 7px 0;
      font: 500 16px/22.5px PingFangSC-Medium, PingFang SC;
    }
  }
}
</style>
